import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useAcceptSharedPatientContact = () => {
  const dispatch = useDispatch();
  const { chat_contacts: errors = {} } = useSelector(state => state.errors);
  const isLoading = useSelector(state => state.loading.effects.chatContacts.acceptSharedContact);
  const [data, setData] = useState(null);

  const accept = (messageId, patient) =>
    dispatch.chatContacts.acceptSharedContact({ messageId, patient }).then(res => {
      setData(res.data.data);
      return res;
    });

  return {
    accept,
    data,
    isLoading,
    errors,
  };
};

const useSharePatientContact = () => {
  const dispatch = useDispatch();
  const { chat_messages: errors = {} } = useSelector(state => state.errors);
  const isLoading = useSelector(state => state.loading.effects.contactMessages.sharePatientContact);

  const share = ({ id: patientUserId }, recipient) =>
    dispatch.contactMessages.sharePatientContact({
      recipient,
      patientUserId,
    });

  return { share, isLoading, errors };
};

export default useSharePatientContact;
